import { useEffect } from "react";
import { useLocation } from "wouter";

import { buildRouteHead } from "@base/site/head";
import type { RouteId } from "@base/site/routes";

import { applyHead } from "./applyHead";

/**
 * Applies the registry head for a route. Pages with head: "page" (blog posts)
 * get the registry placeholder first and override it once their data loads.
 */
export function RouteHead({ id }: { id: RouteId }) {
  const [pathname] = useLocation();
  useEffect(() => {
    applyHead(buildRouteHead(id, "pt-BR", pathname));
  }, [id, pathname]);
  return null;
}
